module.exports = __webpack_public_path__ + "static/media/android.05c42184.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/android.svg
// module id = 230
// module chunks = 0